var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container pa-4 pa-md-8",style:({
			height: _vm.$vuetify.breakpoint.smAndDown
				? 'calc(100dvh - 202px)'
				: 'calc(100dvh - 109px)'
		})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }